"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
/* eslint-disable multiline-comment-style */
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Panel = function (_a) {
    var _b, _c;
    var content = _a.content, position = _a.position, className = _a.className, noPadding = _a.noPadding, style = _a.style, _d = _a.open, open = _d === void 0 ? true : _d;
    var contentClasses = classnames_1.default('Panel__content', className, {
        'Panel__content--noPadding': noPadding,
    });
    var panelClasses = classnames_1.default('Panel', className, {
        'Panel--left': position === 'left',
        'Panel--open': open,
    });
    return (react_1.default.createElement("div", { style: { width: open && ((_b = style === null || style === void 0 ? void 0 : style.width) !== null && _b !== void 0 ? _b : '340px') }, className: panelClasses },
        react_1.default.createElement("div", { style: { width: (_c = style === null || style === void 0 ? void 0 : style.width) !== null && _c !== void 0 ? _c : '340px' }, className: contentClasses }, content)));
};
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map